import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const TextCaptionsIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="m17.73 4.43.16 3.42h-.4a4 4 0 0 0-.33-1.29 2 2 0 0 0-.9-.91q-.54-.3-1.44-.3h-2.05v11.13q0 1.34.29 1.67.4.45 1.25.45h.5v.4H8.65v-.4h.52q.92 0 1.3-.56.25-.34.24-1.56V5.35H8.95q-1.02 0-1.45.15a2 2 0 0 0-.95.78q-.4.58-.48 1.57h-.4l.17-3.42z" />
    </SvgIcon>
);
